import Vue from "vue";

import Vuex from "vuex";

Vue.use(Vuex);

const state = () => ({
  type: 'success',
  text: '',
  show: false
});

const getters = {
  alert: (state) => {
    return state.name;
  },
};


const mutations = {
  showAlert(state, alert) {
    state.type = alert.type
    state.text = alert.text
    state.show = true
    setTimeout(() => {
      state.show = false
    }, 6000);

  },
  closeAlert(state) {
    state.show = false
  }
};

const actions = {
  showAlert(context, alert) {
    context.commit("showAlert", alert);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
